import React from 'react';
import { Link } from 'react-router-dom'
import { convertirPeriodoEnBuscador, convertirPeriodoEnValue, transformText} from '../../../../utils/Tools'


class Buscador extends React.Component {
    constructor(props) {
        super(props)
        this.state = {error: false, errorPeriodo: false }

         // This binding is necessary to make `this` work in the callback
        this.handleCombosBusquedaChange = this.handleCombosBusquedaChange.bind(this);
        this.handleCombosOrigenBusquedaChange = this.handleCombosOrigenBusquedaChange.bind(this);
        this.handleCombosDestinoBusquedaChange = this.handleCombosDestinoBusquedaChange.bind(this);
        this.handleAdultosChange = this.handleAdultosChange.bind(this);
        this.handleMenoresChange = this.handleMenoresChange.bind(this);
        this.handleEdadChange = this.handleEdadChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

  /*  componentDidMount() {
        this.traerDestinosPorOrigen(this.props.busqueda.origen)
    }*/



    dibujarOptionAdultos(cantidad) {
      let options = [];
      if (this.props.solosYsolas) {
          options.push(<option key="0" value="1">1</option>)
      } else if (this.props.busqueda.destino === 'LMG') {
        for (let i = 1; i <= cantidad; i++) {
          options.push(<option key={i} value={i}>{i}</option>)
        }
      } else {
        for (let i = 2; i <= cantidad; i++) {
          options.push(<option key={i} value={i}>{i}</option>)
        }
      }
      return options;
    }

    dibujarOptionMenores(cantidad) {
      let options = [];
      if (!this.props.solosYsolas) {
        for (let i = 0; i <= cantidad; i++) {
          options.push(<option key={i} value={i}>{i}</option>)
        }
      }
      return options;
    }

    handleCombosOrigenBusquedaChange(e) {
        this.props.onSelectOrigenChange(e.target.value);
    }

    handleCombosDestinoBusquedaChange(e) {
        this.props.onSelectDestinoChange(e.target.value);
    }

    handleCombosBusquedaChange(e) {
        this.props.onSelectChange(e.target.name, e.target.value);
    }


    handleAdultosChange(e) {
        this.props.onAdultosChange(e.target.value);
    }

    handleMenoresChange(e) {
        this.props.onMenoresChange(e.target.value);
    }

    handleEdadChange(e) {
        this.props.onEdadChange(e.target.id, e.target.value);
    }

    handleSubmit = (evt) => {
      if (this.props.busqueda.destino === '') {
          this.setState({error: true});
          evt.preventDefault();
          return;
      }

      if (this.props.busqueda.fecha === '' || this.props.busqueda.fecha === '0') {
          this.setState({errorPeriodo: true, error: false});
          evt.preventDefault();
          return;
      }
    }

    render() {
      const estilos = this.props.estilos;

        return (
              <form action="#" method="POST" className={estilos.estilo1}>
                <div className={estilos.estilosInputs + ' input-container'} >
                  <label htmlFor="origen">Origen</label>
                  <select name="origen" value={this.props.busqueda.origen} disabled={this.props.solosYsolas ? 'disabled' : null}
                          onChange={this.handleCombosOrigenBusquedaChange} placeholder="Ingrese desde d&oacute;nde viaja">
                    <option value="">Seleccione origen</option>
                    <option value="CENT">Buenos Aires</option>
                    <option value="ROSC">Rosario</option>
                    <option value="LAPL">La Plata</option>
                  </select>
                </div>
                <div className={estilos.estilosDestinos + ' input-container'} >
                  <label htmlFor="destino">Destino </label> { this.state.error ? <span className="formError">Debe seleccionar un destino</span> : null}
                  <select name="destino" value={this.props.busqueda.destino} disabled={this.props.solosYsolas ? 'disabled' : null}
                          onChange={this.handleCombosDestinoBusquedaChange} placeholder="Ingrese hacia d&oacute;nde viaja">
                      <option value="">Buscar Destino</option>
                      {
                          this.props.busqueda.destinos.map((destino) => {
                              return <option key={ destino.idDestino} value={destino.idDestino}>{transformText(destino.descripcion)}</option>
                          })
                      }
                  </select>

                </div>

                <div className={estilos.estilosInputFecha + ' input-container'} >
                  <label htmlFor="periodo">Per&iacute;odo de viaje</label> { this.state.errorPeriodo ? <span className="formError"> Debe seleccionar un periodo</span> : null}
                  <select name="fecha" value={this.props.busqueda.fecha}  disabled={this.props.solosYsolas ? 'disabled' : null}
                          onChange={this.handleCombosBusquedaChange} className="small">
                    {this.props.busqueda.periodos.length === 0 ? <option value="0">Elegir Periodo</option> : <option value="0">Elegir Periodo</option> }
                    {
                        this.props.busqueda.periodos.map((periodo, index) => {
                            return <option key={index} value={convertirPeriodoEnValue(periodo)}>{convertirPeriodoEnBuscador(periodo)}</option>
                        })
                    }

                  </select>

                  {/*<div className="input-group-prepend">
                    <Link to='/'><i className="material-icons">event</i></Link>
                  </div>*/}
                </div>
                {/*<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 input-habitaciones input-container">
                  <label htmlFor="habitaciones">Habitaciones</label>
                  <select name="habitaciones" id="habitaciones">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4 o m&aacute;s</option>
                  </select>
                </div>*/}
                  <div className={estilos.estilosAdultosMenores + " habitaciones-container input-container"}>
                <div className="habitaciones">

                  <div className="row">
                    {/*<label className="d-block">Habitaci&oacute;n 1</label>*/}
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-8">
                      <label htmlFor="adultos">Adultos (+2 años)</label>
                      <select name="adultos" value={this.props.busqueda.adultos} onChange={this.handleAdultosChange}>
                        {
                          this.dibujarOptionAdultos(6)
                        }
                      </select>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-8">
                      <label htmlFor="menores">Menores de 2 años</label>
                      <select name="menores" value={this.props.busqueda.menores.length} disabled={this.props.solosYsolas ? 'disabled' : null}
                              onChange={this.handleMenoresChange}>
                        {
                          this.dibujarOptionMenores(6)
                        }
                      </select>
                    </div>
                    {

                    this.props.busqueda.menores.map((value, key) => {

                        return (<div key={key} className={estilos.estiloEdadMenor}>
                                  <label>Edad</label>
                                  <select id={key} value={value} onChange={this.handleEdadChange} >
                                    {
                                      this.dibujarOptionMenores(1)
                                    }
                                  </select>
                                </div>
                              )
                    })
                  }
                  </div>
                </div>
              </div>
                <div className={estilos.estiloBoton}>
                    <Link to={`/paquetes-turisticos/${this.props.busqueda.origen}/${this.props.busqueda.destino}/${this.props.busqueda.fecha}/`}
                          onClick={this.handleSubmit} >
                      <input type="submit" disabled={this.props.solosYsolas ? 'disabled' : null} value="Buscar" />
                    </Link>
                </div>
              </form>
            );
    }
}

export default Buscador



// WEBPACK FOOTER //
// ./src/components/Home/SeccionBuscador/Buscador/index.js